export const getPrefix = (lang) => {
    return lang === "en" ? "/en" : ""
}